import React from 'react';
import { cn } from '@dashboard/lib/utils';

export const TRIGGER_LABEL = 'Conditional trigger';

export default function ConditionalBranchIcon({ className, ...props }) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cn('size-3 shrink-0', className)}
      {...props}
    >
      <circle cx="4" cy="3" r="1.5" />
      <circle cx="4" cy="11" r="1.5" />
      <circle cx="10" cy="7" r="1.5" />
      <path d="M4 4.5v5" />
      <path d="M4 7h4.5" />
    </svg>
  );
}
